(function() {
  'use strict';
  var selectedTier = 2;

  window.selectHeroPdpTier = function(el) {
    var tier = parseInt(el.dataset.tier, 10);
    var price = el.dataset.price;
    selectedTier = tier;
    document.querySelectorAll('.hero-pdp-tier').forEach(function(card) { card.classList.remove('selected'); });
    el.classList.add('selected');
    var stickyPrice = document.getElementById('sticky-price');
    if (stickyPrice) stickyPrice.textContent = '$' + price;
    var bonus = document.getElementById('bonus-banner');
    if (bonus) bonus.style.display = tier >= 2 ? 'block' : 'none';
  };

  window.changeGalleryImage = function(btn) {
    var src = btn.dataset.src;
    var mainImg = document.getElementById('gallery-main-img');
    if (mainImg && src) mainImg.src = src;
    document.querySelectorAll('.hero-pdp-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  function addToCart() {
    var config = window.heroPdpConfig;
    if (!config) { console.error('Hero PDP: Config not found.'); return; }
    var tierConfig = config.tiers[selectedTier];
    if (!tierConfig) { console.error('Hero PDP: Invalid tier:', selectedTier); return; }

    var items = tierConfig.items.map(function(item) {
      var lineItem = { id: item.id, quantity: item.quantity };
      if (tierConfig.bundleName) { lineItem.properties = { '_bundle': tierConfig.bundleName }; }
      return lineItem;
    });

    var btn = document.getElementById('hero-pdp-atc');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) {
      if (!response.ok) return response.json().then(function(err) { throw new Error(err.description || 'Failed to add to cart'); });
      return response.json();
    })
    .then(function() { window.location.href = config.cartUrl; })
    .catch(function(error) {
      console.error('Hero PDP ATC error:', error);
      alert('Sorry, there was an error adding to cart. Please try again.');
    })
    .finally(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Get Relief Now'; }
      if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Get Relief Now'; }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    var mainBtn = document.getElementById('hero-pdp-atc');
    if (mainBtn) mainBtn.addEventListener('click', addToCart);
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    var mainCta = document.getElementById('hero-pdp-atc');
    if (mainCta && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var sticky = document.getElementById('sticky-atc');
          if (sticky && window.innerWidth <= 768) sticky.classList.toggle('visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(mainCta);
    }

    var bonus = document.getElementById('bonus-banner');
    if (bonus) bonus.style.display = 'block';
  });
})();